import React from 'react';
import { CheckCircle, Clock, XCircle } from 'lucide-react';

const timelineEvents = [
  {
    id: 1,
    title: 'IT Infrastructure Proposal',
    date: '2024-03-10',
    status: 'completed',
    description: 'Proposal submitted successfully',
    value: '$2.4M',
  },
  {
    id: 2,
    title: 'Cybersecurity Assessment',
    date: '2024-03-08',
    status: 'in_progress',
    description: 'Technical review in progress',
    value: '$1.8M',
  },
  {
    id: 3,
    title: 'Cloud Migration Project',
    date: '2024-03-05',
    status: 'rejected',
    description: 'Bid not selected - price point too high',
    value: '$3.2M',
  },
];

export function BidTimeline() {
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'completed':
        return <CheckCircle className="h-5 w-5 text-green-500" />;
      case 'in_progress':
        return <Clock className="h-5 w-5 text-yellow-500" />;
      case 'rejected':
        return <XCircle className="h-5 w-5 text-red-500" />;
      default:
        return null;
    }
  };

  return (
    <div className="rounded-lg bg-white p-6 shadow">
      <h3 className="text-lg font-medium text-gray-900">Recent Bid Activity</h3>
      <div className="mt-6 flow-root">
        <ul className="-mb-8">
          {timelineEvents.map((event, eventIdx) => (
            <li key={event.id}>
              <div className="relative pb-8">
                {eventIdx !== timelineEvents.length - 1 ? (
                  <span
                    className="absolute left-4 top-4 -ml-px h-full w-0.5 bg-gray-200"
                    aria-hidden="true"
                  />
                ) : null}
                <div className="relative flex space-x-3">
                  <div>
                    <span
                      className={`flex h-8 w-8 items-center justify-center rounded-full ring-8 ring-white ${
                        event.status === 'completed'
                          ? 'bg-green-500'
                          : event.status === 'in_progress'
                          ? 'bg-yellow-500'
                          : 'bg-red-500'
                      }`}
                    >
                      {getStatusIcon(event.status)}
                    </span>
                  </div>
                  <div className="flex min-w-0 flex-1 justify-between space-x-4 pt-1.5">
                    <div>
                      <h3 className="font-medium text-gray-900">{event.title}</h3>
                      <p className="mt-1 text-sm text-gray-500">{event.description}</p>
                    </div>
                    <div className="whitespace-nowrap text-right text-sm text-gray-500">
                      <time dateTime={event.date}>{event.date}</time>
                      <div className="mt-1">
                        <span className="rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-800">
                          {event.value}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}